export default {
	notification_health: 'בריאות התראות',
	notification_health_summary: 'סיכום',
	notification_health_loading: 'בודק בריאות התראות...',
	notification_health_refresh: 'רענון',
	notification_health_fix: 'מה לעשות',
	notification_health_unavailable: 'לא ניתן לטעון את בריאות ההתראות',
	notification_health_healthy: 'תקין',
	notification_health_blocked: 'חסום',
	notification_health_degraded: 'דורש טיפול',
	notification_health_no_app_user: 'לא התחבר לאפליקציה',
	notification_health_unknown: 'לא ידוע',
	notification_health_app_version: 'גרסת אפליקציה',
	notification_health_last_delivery: 'משלוח אחרון',
	notification_health_time_just_now: 'הרגע',
	notification_health_time_minutes: 'לפני {count} דקות',
	notification_health_time_hours: 'לפני {count} שעות',
	notification_health_time_days: 'לפני {count} ימים',
	notification_health_time_unknown: 'לא ידוע',
	notification_health_summary_healthy: 'ההתראות אמורות לעבוד',
	notification_health_summary_no_app_user: 'המנקה לא התחבר לאפליקציה',
	notification_health_summary_blocked_no_token: 'אסימון ההתראות חסר — המנקה חייב לפתוח את האפליקציה ולהתחבר',
	notification_health_summary_blocked_off: 'ההתראות כבויות באפליקציה',
	notification_health_check_portal_contact_label: 'איש קשר קיים בפורטל',
	notification_health_check_portal_active_label: 'איש קשר פעיל',
	notification_health_check_portal_rooms_label: 'חדרים משויכים',
	notification_health_check_portal_shifts_label: 'משמרות משויכות',
	notification_health_check_app_user_label: 'מחובר לאפליקציה',
	notification_health_check_push_token_label: 'אסימון התראות רשום',
	notification_health_check_notification_mode_label: 'מצב התראות',
	notification_health_check_time_schedule_label: 'בתוך חלון זמן ההתראות',
	notification_health_check_ios_geo_filter_label: 'מסנן מיקום iOS',
	notification_health_check_recent_push_attempt_label: 'ניסיון התראה אחרון (48 שעות)',
	notification_health_check_last_push_ignored_label: 'האות האחרון לא נשלח',
	notification_health_check_recent_push_delivered_label: 'התראה נמסרה לאחרונה (48 שעות)',
	notification_health_detail_portal_contact_found: 'נמצא בפורטל',
	notification_health_detail_portal_contact_missing: 'לא נמצא רשומת איש קשר',
	notification_health_detail_portal_active_active: 'פעיל',
	notification_health_detail_portal_active_inactive: 'לא פעיל',
	notification_health_detail_portal_rooms_assigned: '{count} חדרים',
	notification_health_detail_portal_rooms_none: 'לא שויכו חדרים',
	notification_health_detail_portal_shifts_assigned: '{count} משמרות',
	notification_health_detail_portal_shifts_none: 'לא שויכו משמרות',
	notification_health_detail_app_user_logged_in: 'גרסת אפליקציה {version}, סנכרון אחרון {lastSync}',
	notification_health_detail_app_user_never: 'מעולם לא התחבר',
	notification_health_detail_push_token_present: 'אסימון FCM קיים',
	notification_health_detail_push_token_empty: 'האסימון ריק',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'השעה הנוכחית בתוך לוח הזמנים',
	notification_health_detail_time_schedule_outside: 'השעה הנוכחית מחוץ ללוח הזמנים',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'אין ניסיונות התראה ב-48 השעות האחרונות',
	notification_health_detail_last_push_ignored: 'בקשת ההתראה האחרונה בוטלה (סרוויק לא מוגדר לאזור עבודה)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'אין מסירות מוצלחות ב-48 השעות האחרונות',
	notification_health_fix_portal_contact: 'צור את המנקה בלוח המשתמשים',
	notification_health_fix_portal_active: 'הפעל את מתג הפעיל עבור מנקה זה',
	notification_health_fix_portal_rooms: 'שייך לפחות חדר אחד למנקה זה',
	notification_health_fix_portal_shifts: 'שייך לפחות משמרת אחת',
	notification_health_fix_app_user: 'המנקה חייב להתקין את האפליקציה ולהתחבר עם מספר טלפון זה',
	notification_health_fix_push_token: 'בקש מהמנקה לפתוח את האפליקציה, לאשר התראות בהגדרות iOS ולהתחבר שוב',
	notification_health_fix_notification_mode: 'שנה מצב התראות מכבוי לתמיד באפליקציה',
	notification_health_fix_time_schedule: 'המתן לחלון המתוזמן או שנה מצב לתמיד',
	notification_health_fix_ios_geo_filter: 'המנקה מחוץ לאזור ההתראות — בקש שיפתח את האפליקציה באתר',
	notification_health_fix_last_push_ignored: 'בדוק הגדרות סרוויק לאזור העבודה של החדר ששלח את האות',
	notification_health_fix_recent_push_delivered_filters: 'בדוק מסנני התראות או הגדרות מכשיר',
	notification_health_fix_recent_push_delivered_token: 'רשום אסימון התראות תחילה',
	notification_health_mode_on: 'תמיד',
	notification_health_mode_off: 'כבוי',
	notification_health_mode_time: 'לפי זמן',
	notification_health_mode_location: 'לפי מיקום',
	notification_health_filter_on: 'פעיל',
	notification_health_filter_off: 'כבוי',
};
